// This file should include all tests running in the form of
// export const [TEST_NAME] = [TEST_NUMBER]
module.exports = {
    LAYOUT_PERFORMANCE_FE_GUILD: 4303,
    DOLPHINS_LOHP_PRO_PACKAGES: 4899,
    DOLPHINS_TOF_PRO_REDIRECT: 4831,
    MUSTANGS_LOHP_LONG_TERM_HIRING_EXPERIMENT: 4923,
    LYNXES_EXPANDABLE_SEARCH_BAR: 4973,
    LYNXES_BRAND_LOHP: 4971,
    LYNXES_BUYER_PROFILE_REDESIGN: 4935,
    LYNXES_SEAMLESS_ONBOARDING_AND_ROUTING_V4: 5010,
};
